import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    ORFButton as Button
    , OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
} from '../../../../../../common/forms/order-request-form.component';
import { newQuotationActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-quotation.reducer";
import { requestLogActions } from "./../../../../../../../store/external/request-reducer/request-log.reducer";

class QuotationBusinessForm extends Component {
    constructor(props) {
        super(props);
    }

    submitRequest = async () => {
        const { modalMessage, submitRequest, fetchRequestLogItems } = this.props;

        var success = await submitRequest();
        if (success.Success) {
            fetchRequestLogItems(0);
        }
        modalMessage(success);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const {
            //component props
            onClickCancel
            , prevAction
            // form
            , quotationBusinessFormA
            // reducer action
        } = this.props;

        const { purposeOfUseOptions, formSubmitted } = this.props.quotationRequest;

        return (
            <div>
                <Form method="post" role="form"
                    model="quotationBusinessFormA"
                    onSubmit={this.submitRequest}
                >
                    <div >
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('purpose_of_use')} *`}
                                    options={purposeOfUseOptions}
                                    placeholder={this.toLocaleLanguage('select_purpose')}
                                    fieldProp='.purposeOfUseId'
                                    value={quotationBusinessFormA.purposeOfUseId}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea
                                    label={`${this.toLocaleLanguage('business_justification')} *`}
                                    fieldProp='.businessJustification'
                                    value={quotationBusinessFormA.businessJustification}
                                    maxLength={"350"}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea
                                    label={this.toLocaleLanguage('additional_information')}
                                    fieldProp='.additionalInformation'
                                    value={quotationBusinessFormA.additionalInformation}
                                    maxLength={"100"}
                                />
                            </Col>
                        </Row>
                        <div className="request-button-continer">
                            <div className="bottom-left">
                                <Button
                                    label={this.toLocaleLanguage('modal_close_cancel_button')}
                                    variant={"light"}
                                    action={onClickCancel}
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('back')}
                                        variant={"outline-secondary"}
                                        action={prevAction}
                                    />
                                </div>
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('submit_request_button')}
                                        variant={"primary"}
                                        type={"submit"}
                                        disabled={
                                            quotationBusinessFormA.purposeOfUseId == 0
                                            || quotationBusinessFormA.businessJustification == ''
                                            || formSubmitted
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};
export default connect(
    state => {
        const { quotationRequest, translation } = state;
        const { quotationBusinessFormA } = state.form;
        return {
            quotationRequest
            , quotationBusinessFormA
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newQuotationActions
                , requestLogActions),
            dispatch
        )
)(QuotationBusinessForm);
